import styled from 'styled-components';

export const OptionsContainer = styled.div`
    & svg {
        height: 20px;
        width: 20px;
        fill: ${({ theme }) => theme.grey};
    }
`;